'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["color", "icon", "Icon", "menuWidth", "onColorChange", "onOpenChange", "onPickerModeChange", "onResetClick", "open", "tooltipPlacement", "tooltip", "DropdownContent", "disabled"];
import Controllable from 'UIComponents/decorators/Controllable';
import { AbstractDropdown, DropdownCaret } from 'foundations-components/transitional/components/AbstractDropdown';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { rgba } from 'foundations-components/transitional/utils/color';
import { callIfPossible } from 'foundations-components/transitional/utils/functions';
import styled from 'foundations-theming/utils';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { TextToolbarIcon } from './TextToolbarIcon';
import SimpleStyledClickable from './internal/SimpleStyledClickable';
import { jsx as _jsx } from "react/jsx-runtime";
const ColorIconBorderWrapper = styled.div.withConfig({
  displayName: "UITextToolbarColorDropdown__ColorIconBorderWrapper",
  componentId: "n4a6iu-0"
})(({
  $opacity,
  $currentColor
}) => ({
  borderBlockEndColor: rgba($currentColor, $opacity),
  borderBlockEndStyle: 'solid',
  borderBlockEndWidth: '2px',
  blockSize: '22px',
  inlineSize: '18px',
  marginBlockEnd: '2px'
}));
const ColorIconButton = props => {
  return /*#__PURE__*/_jsx(SimpleStyledClickable, Object.assign({}, props, {
    display: "flex",
    alignItems: "flex-start"
  }));
};
const COLORPICKER_SIMPLE_MODE = 'simple';
class UITextToolbarColorDropdownCore extends Component {
  constructor(props) {
    super(props);
    this.handleOpenChange = evt => {
      const {
        onOpenChange
      } = this.props;
      if (evt.target.value === true) {
        this.setState({
          pickerMode: COLORPICKER_SIMPLE_MODE
        });
      }
      onOpenChange(evt);
    };
    this.handleColorChange = update => {
      const {
        onColorChange,
        onOpenChange
      } = this.props;
      const {
        pickerMode
      } = this.state;
      onColorChange(syntheticEvent(update));
      if (pickerMode === COLORPICKER_SIMPLE_MODE) {
        onOpenChange(syntheticEvent(false));
      }
    };
    this.handlePickerModeChange = evt => {
      const {
        onPickerModeChange
      } = this.props;
      this.setState({
        pickerMode: evt.target.value
      });
      callIfPossible(onPickerModeChange, evt);
    };
    this.state = {
      pickerMode: COLORPICKER_SIMPLE_MODE
    };
  }
  render() {
    const _this$props = this.props,
      {
        color: currentColor,
        Icon,
        menuWidth,
        onResetClick,
        open,
        tooltipPlacement = 'bottom',
        tooltip,
        DropdownContent,
        disabled
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      pickerMode
    } = this.state;
    const {
      color,
      alpha
    } = currentColor;
    const opacity = alpha != null ? alpha / 100 : 1;
    const renderedIcon =
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(ColorIconBorderWrapper, {
      "data-test-id": "color-icon-border-wrapper",
      $opacity: opacity,
      $currentColor: color,
      children: /*#__PURE__*/_jsx(TextToolbarIcon, {
        icon: Icon,
        disabled: disabled,
        paddingBlockStart: "50"
      })
    });
    return /*#__PURE__*/_jsx(Tooltip, {
      open: open ? false : undefined,
      placement: tooltipPlacement,
      title: tooltip,
      disabled: disabled,
      children: /*#__PURE__*/_jsx(AbstractDropdown, Object.assign({
        Button: ColorIconButton,
        buttonText: renderedIcon,
        caretRenderer: /*#__PURE__*/_jsx(DropdownCaret, {
          buttonUse: "transparent"
        }),
        menuWidth: menuWidth,
        onOpenChange: this.handleOpenChange,
        open: open,
        disabled: disabled
      }, rest, {
        children: /*#__PURE__*/_jsx(DropdownContent, {
          alpha: alpha,
          color: color,
          pickerMode: pickerMode,
          onChange: this.handleColorChange,
          onOpenChange: this.handleOpenChange,
          onPickerModeChange: this.handlePickerModeChange,
          onResetClick: onResetClick
        })
      }))
    });
  }
}
UITextToolbarColorDropdownCore.displayName = 'UITextToolbarColorDropdownCore';
UITextToolbarColorDropdownCore.propTypes = {
  color: PropTypes.shape({
    color: PropTypes.string,
    alpha: PropTypes.number
  }),
  DropdownContent: PropTypes.elementType.isRequired,
  menuWidth: PropTypes.number,
  onColorChange: PropTypes.func,
  onOpenChange: PropTypes.func,
  onPickerModeChange: PropTypes.func,
  onResetClick: PropTypes.func,
  open: PropTypes.bool,
  tooltipPlacement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  tooltip: PropTypes.any,
  disabled: PropTypes.bool
};
const UITextToolbarColorDropdown = Controllable(UITextToolbarColorDropdownCore, ['open', 'color']);
UITextToolbarColorDropdown.displayName = 'UITextToolbarColorDropdown';
export default UITextToolbarColorDropdown;